import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import HOAPartnership from "./components/HOAPartnership";
import VirtualGuardStandards from "./components/VirtualGuardStandards";
import AnalyticsTracker from "./components/AnalyticsTracker";
import ScrollToTop from "./components/ScrollToTop";
import DesignGallery from "./pages/DesignGallery";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/design-options" element={<DesignGallery />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy-policy" element={
            <>
              <AnalyticsTracker pageName="Redline Monitoring Services Inc. - Privacy Policy" customData={{ page_type: 'legal' }} />
              <PrivacyPolicy />
            </>
          } />
          <Route path="/terms-of-service" element={
            <>
              <AnalyticsTracker pageName="Redline Monitoring Services Inc. - Terms of Service" customData={{ page_type: 'legal' }} />
              <TermsOfService />
            </>
          } />
          <Route path="/hoa-partnership" element={
            <>
              <AnalyticsTracker pageName="Redline Monitoring Services Inc. - HOA Partnership" customData={{ page_type: 'business', service_interest: 'hoa_partnership' }} />
              <HOAPartnership />
            </>
          } />
          <Route path="/virtual-guard-standards" element={
            <>
              <AnalyticsTracker pageName="Redline Monitoring Services Inc. - Virtual Guard Standards" customData={{ page_type: 'business', service_interest: 'virtual_guard_standards' }} />
              <VirtualGuardStandards />
            </>
          } />
        </Routes>
        <ScrollToTop />
      </BrowserRouter>
    </div>
  );
}

export default App;
